import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import ErrorView from 'v2/components/error/ErrorView';
import { Spin } from 'antd';
import LoadingListSuccessView from './components/LoadingListSuccessView';
import { fetchProjects } from 'v2/store/projectList/actions/FetchProjects';

const ProjectListContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProjects());
  }, []);

  const { isLoadingInit, projectsError } = useSelector(
    (state: RootState) => state.projectList
  );

  if (isLoadingInit) {
    return <Spin className="app-spin" />;
  }

  if (projectsError) {
    return (
      <ErrorView
        onButtonClick={() => {
          dispatch(fetchProjects());
        }}
      />
    );
  }

  return <LoadingListSuccessView />;
};

export default ProjectListContent;
